<template>
  <div>
    <Header :title="title" :showBack="true"></Header>
    <div class="LineTitle">
      {{ lineName }}<span style="float: right">{{ classTime }}</span>
    </div>
    <van-search v-model="searchNode" placeholder="站点名搜索" />
    <div>
      <van-row>
        <van-col span="12">
          <van-cell
            is-link
            :title="selectStartNodeGroup"
            @click="startNodeShow = true"
            style="padding: 0.1rem 0.2rem"
        /></van-col>
        <van-col span="12">
          <van-cell
            is-link
            :title="selectArrivalNodeGroup"
            @click="arrivalNodeShow = true"
            style="padding: 0.1rem 0.2rem"
        /></van-col>
        <!-- <van-col span="5"
          ><van-button
            plain
            type="primary"
            block
            @click="selectAll"
            style="height: 1rem"
            >全选</van-button
          ></van-col
        > -->
        <van-col span="6"
          ><van-button
            plain
            type="primary"
            block
            @click="editClick(null, 2)"
            style="height: 1rem"
            >修改勾选</van-button
          ></van-col
        >
        <van-col span="6"
          ><van-button
            plain
            type="info"
            block
            @click="editClick(null, 3)"
            style="height: 1rem"
            >修改全部</van-button
          ></van-col
        >
      </van-row>
    </div>
    <div style="padding-bottom: 1rem">
      <div
        v-for="price of lineClassDayPriceList"
        :key="price.GID"
        class="priceList"
        @click="price.selectChecked = !price.selectChecked"
      >
        <van-row class="priceTitle">
          <van-col span="2">
            <van-checkbox v-model="price.selectChecked"
          /></van-col>
          <van-col span="6"> {{ price.StartNodeName }}</van-col>
          <van-col span="8">————</van-col>
          <van-col span="8">{{ price.ArrivalNodeName }}</van-col>
        </van-row>

        <div class="priceDetail">
          <van-row>
            <van-col span="2">{{ price.FullPrice }}</van-col>
            <van-col span="2">{{ price.HalfPrice }}</van-col>
            <van-col span="2">{{ price.OfferPrice }}</van-col>
            <van-col span="2">{{ price.StationFee }}</van-col>
            <van-col span="2">{{ price.RoundTripPrice }}</van-col>
            <van-col span="2">{{ price.BackTripPrice }}</van-col>
            <van-col span="2">{{ price.StudentPrice }}</van-col>
            <van-col span="2">{{ price.MilitaryOrDisabilityPrice }}</van-col>
            <!-- <van-col span="2">{{ price.OldiePrice }}</van-col> -->
            <van-col span="3">{{ price.CustomPrice }}</van-col>
            <!-- <van-col span="2">{{ price.PackagePrice }}</van-col> -->
          </van-row>
          <van-row>
            <van-col span="2">全</van-col>
            <van-col span="2">半</van-col>
            <van-col span="2">优</van-col>
            <van-col span="2">站务</van-col>
            <van-col span="2">双程</van-col>
            <van-col span="2">回程</van-col>
            <van-col span="2">学生</van-col>
            <van-col span="2">军残</van-col>
            <!-- <van-col span="2">老人</van-col> -->
            <van-col span="3">自定义</van-col>
            <!-- <van-col span="2">套票</van-col> -->
          </van-row>
        </div>
        <div class="btnDiv">
          <van-button
            plain
            size="mini"
            color="black"
            @click.stop="editClick(price, 1)"
            >&nbsp;修 改&nbsp;</van-button
          >
        </div>
      </div>
      <!-- 分页 -->
      <van-pagination
        v-model="pageNumber"
        :total-items="total"
        :items-per-page="pageSize"
        force-ellipses
        v-if="lineClassDayPriceList"
        @change="changePaginationPage"
      />
    </div>

    <van-action-sheet
      v-model="startNodeShow"
      :actions="startNodeActionsGroup"
      @select="onStartNodeGroupSelect"
    />

    <van-action-sheet
      v-model="arrivalNodeShow"
      :actions="arrivalNodeActionsGroup"
      @select="onArrivalNodeGroupSelect"
    />

    <van-dialog
      v-model="editPriceShow"
      show-cancel-button
      v-if="seletPrice"
      @confirm="onCommintPriceEdit"
    >
      <div class="dialogEdit">
        <van-radio-group
          v-model="editTypeRadio"
          direction="horizontal"
          style="margin-left: 0.5rem"
        >
          <van-radio name="1">数字</van-radio>
          <van-radio name="2" style="margin-left: 0.5rem">百分率%</van-radio>
        </van-radio-group>
        <van-cell-group>
          <!-- 允许输入数字，调起带符号的纯数字键盘 -->
          <van-field
            v-model="seletPrice.FullPrice"
            :formatter="formatter"
            type="number"
            label="全票价"
          />
          <van-field
            v-model="seletPrice.HalfPrice"
            :formatter="formatter"
            type="number"
            label="半票价"
          />
          <van-field
            v-model="seletPrice.OfferPrice"
            :formatter="formatter"
            type="number"
            label="优惠价"
          />
          <van-field
            v-model="seletPrice.StationFee"
            :formatter="formatter"
            type="number"
            label="站务费"
          />
          <van-field
            v-model="seletPrice.RoundTripPrice"
            :formatter="formatter"
            type="number"
            label="双程票价"
          />
          <van-field
            v-model="seletPrice.BackTripPrice"
            :formatter="formatter"
            type="number"
            label="回程票价"
          />
          <van-field
            v-model="seletPrice.StudentPrice"
            :formatter="formatter"
            type="number"
            label="学生票价"
          />
          <van-field
            v-model="seletPrice.MilitaryOrDisabilityPrice"
            :formatter="formatter"
            type="number"
            label="军残票价"
          />
          <!-- <van-field
            v-model="seletPrice.OldiePrice"
            :formatter="formatter"
            type="number"
            label="老人票价"
          /> -->
          <van-field
            v-model="seletPrice.CustomPrice"
            :formatter="formatter"
            type="number"
            label="自定义票价"
          />
          <!-- <van-field
            v-model="seletPrice.PackagePrice"
            :formatter="formatter"
            type="number"
            label="套票价"
          /> -->
        </van-cell-group>
      </div>
    </van-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "班次票价", //页面标题
      lineClassDayGID: this.$route.query["LineClassDayGID"], //班次id
      lineGID: this.$route.query["LineGID"], //线路GID
      lineName: this.$route.query["LineName"], //线路名称
      classTime: this.$route.query["ClassTime"], //班次时间
      orgLineClassDayPriceList: [],
      lineClassDayPriceList: [],
      searchNode: "",
      //nodeShow: false,
      startNodeShow: false,
      arrivalNodeShow: false,
      //nodeGroupList: [],
      startNodeGroupList: [],
      arrivalNodeGroupList: [],

      //nodeGroup: [{ name: "取消选择" }],
      startNodeActionsGroup: [{ name: "取消选择" }],
      arrivalNodeActionsGroup: [{ name: "取消选择" }],
      startNodeGroup: "",
      arrivalNodeGroup: "",
      //selectNodeGroup: "点击选择站点分组",
      selectStartNodeGroup: "点击选择上车站点分组",
      selectArrivalNodeGroup: "点击选择下车站点分组",
      editPriceShow: false,
      seletPrice: null,
      editTypeRadio: "1",
      OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
      pageNumber: 1,
      pageSize: 10,
      total: 0,
    };
  },
  watch: {
    searchNode(v) {
      this.pageNumber = 1;
      this.total = 0;
      this.lineClassDayPriceList = [];
      this.getLineClassDayPrice(v);
      if (!v) {
        this.lineClassDayPriceList = this.orgLineClassDayPriceList;
      }
      this.orgLineClassDayPriceList.forEach((element) => {
        if (
          element.StartNodeName.indexOf(v) >= 0 ||
          element.ArrivalNodeName.indexOf(v) >= 0
        ) {
          let needAdd = true;
          if (this.lineClassDayPriceList.length == 0) {
            needAdd = true;
          } else {
            this.lineClassDayPriceList.forEach((item) => {
              if (item.GID == element.GID) {
                needAdd = false;
              }
            });
          }
          if (needAdd) {
            this.lineClassDayPriceList.push(element);
          }
        }
      });
    },
  },
  methods: {
    //全选
    selectAll() {
      let s = false;
      s = !this.lineClassDayPriceList[0].selectChecked;
      this.lineClassDayPriceList.forEach((item) => {
        item.selectChecked = s;
      });
    },
    //提交票价修改
    onCommintPriceEdit() {
      var _jsonText = {
        FullPrice: this.seletPrice.FullPrice ? this.seletPrice.FullPrice : 0,
        HalfPrice: this.seletPrice.HalfPrice ? this.seletPrice.HalfPrice : 0,
        OfferPrice: this.seletPrice.OfferPrice ? this.seletPrice.OfferPrice : 0,
        RoundTripPrice: this.seletPrice.RoundTripPrice
          ? this.seletPrice.RoundTripPrice
          : 0,
        BackTripPrice: this.seletPrice.BackTripPrice
          ? this.seletPrice.BackTripPrice
          : 0,
        StudentPrice: this.seletPrice.StudentPrice
          ? this.seletPrice.StudentPrice
          : 0,
        MilitaryOrDisabilityPrice: this.seletPrice.MilitaryOrDisabilityPrice
          ? this.seletPrice.MilitaryOrDisabilityPrice
          : 0,
        // OldiePrice: this.seletPrice.OldiePrice ? this.seletPrice.OldiePrice : 0,
        CustomPrice: this.seletPrice.CustomPrice ? this.seletPrice.CustomPrice : 0,
        // PackagePrice: this.seletPrice.PackagePrice ? this.seletPrice.PackagePrice : 0,
        StationFee: this.seletPrice.StationFee ? this.seletPrice.StationFee : 0,
        RecordType: this.seletPrice.RecordType,
        GIDList: this.seletPrice.GID,
        TypesOf: this.editTypeRadio,
        _CompGID: this.OperObj.CompGID,
        ModifyGID: this.OperObj.GID,
        ModifyCode: this.OperObj.UserCode,
        ModifyName: this.OperObj.UserName,
      };
      let params = {
        _jsonText: JSON.stringify(_jsonText),
      };
      this.$http
        .post(
          this.$api.lineClassDayPriceBatchEditSave,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            this.editPriceShow = false;
            this.seletPrice = null;
            this.$toast("修改成功");
            this.pageNumber = 1;
            this.total = 0;
            this.getLineClassDayPrice();
          }
        });
    },
    //点击修改按钮
    editClick(item, type) {
      this.editTypeRadio = "1";
      if (type == 1) {
        this.editPriceShow = true;
        this.seletPrice = item;
        //this.seletPrice.editTypeRadio = "1";
      }
      if (type == 2) {
        let priceList = [];
        let gidList = "";
        this.editPriceShow = true;
        this.lineClassDayPriceList.forEach((item) => {
          if (item.selectChecked) {
            priceList.push(item);
            gidList += item.GID + ",";
          }
        });
        if (priceList.length <= 0) {
          this.editPriceShow = false;
          this.$toast("未选择要修改的票价记录");
          return;
        }
        this.seletPrice = priceList[0];
        this.seletPrice.GID = gidList.substring(0, gidList.length - 1);
      }
      if (type == 3) {
        let priceList = [];
        this.editPriceShow = true;
        this.lineClassDayPriceList.forEach((item) => {
          priceList.push(item);
        });
        this.seletPrice = priceList[0];
        this.seletPrice.GID = priceList[0].LineClassDayGID;
        this.seletPrice.RecordType = "LineClassDay";
      }
    },
    //将输入数值格式化
    formatter(value) {
      // if (!value) {
      //   return 0;
      // }
      if (value < 0) {
        return 0;
      }
      return value;
    },
    // 分页页码改变时触发
    changePaginationPage() {
      this.lineClassDayPriceList = [];
      var v = this.searchNode;
      if (v) {
        this.getLineClassDayPrice(v);
      } else {
        this.getLineClassDayPrice();
      }
    },
    //获取班次票价
    getLineClassDayPrice(val) {
      this.$http
        .post(
          this.$api.geiLineClassDayPrice,
          this.$qs.stringify({
            page: this.pageNumber,
            start: (this.pageNumber - 1) * this.pageSize,
            limit: this.pageSize,
            LineClassDayGID: this.lineClassDayGID,
            query: val,
            StartNodeGroup: this.startNodeGroup,
            ArrivalNodeGroup: this.arrivalNodeGroup,
          })
        )
        .then((res) => {
          if (res.success) {
            this.total = res.total;
            res.data.forEach((item) => {
              item.selectChecked = false;
            });
            this.orgLineClassDayPriceList = res.data;
            // this.orgLineClassDayPriceList.forEach((item) => {
            //   let needAdd = true;
            //   this.nodeGroup.forEach((ng) => {
            //     if (item.NodeGroup == ng.name) {
            //       needAdd = false;
            //     }
            //   });
            //   if (needAdd) {
            //     this.nodeGroup.push({
            //       name: item.NodeGroup,
            //     });
            //   }
            // });
            this.lineClassDayPriceList = res.data;
          }
        });
    },
    //获取上车点站点分组
    onLineStartNodeNodeGroupNameQuery() {
      this.$http
        .post(
          this.$api.onLineStartNodeNodeGroupNameQuery,
          this.$qs.stringify({
            LineGID: this.lineGID,
          })
        )
        .then((res) => {
          if (res.success) {
            this.startNodeGroupList = res.data;
            this.startNodeGroupList.forEach((item) => {
              let needAdd = true;
              this.startNodeActionsGroup.forEach((ng) => {
                if (item.NodeGroup == ng.name) {
                  needAdd = false;
                }
              });
              if (needAdd) {
                this.startNodeActionsGroup.push({
                  name: item.NodeGroup,
                });
              }
            });
          }
        });
    },

    //获取下车点站点分组
    onLineArrivalNodeNodeGroupNameQuery() {
      this.$http
        .post(
          this.$api.onLineArrivalNodeNodeGroupNameQuery,
          this.$qs.stringify({
            LineGID: this.lineGID,
          })
        )
        .then((res) => {
          if (res.success) {
            this.arrivalNodeGroupList = res.data;
            this.arrivalNodeGroupList.forEach((item) => {
              let needAdd = true;
              this.arrivalNodeActionsGroup.forEach((ng) => {
                if (item.NodeGroup == ng.name) {
                  needAdd = false;
                }
              });
              if (needAdd) {
                this.arrivalNodeActionsGroup.push({
                  name: item.NodeGroup,
                });
              }
            });
          }
        });
    },

    //上车站点分组选择
    onStartNodeGroupSelect(item) {
      this.pageNumber = 1;
      this.total = 0;
      this.selectStartNodeGroup =
        item.name == "取消选择" ? "点击选择上车站点分组" : item.name;
      this.lineClassDayPriceList = [];
      if (item.name == "取消选择") {
        this.startNodeGroup = "";
        this.getLineClassDayPrice();
        //this.lineClassDayPriceList = this.orgLineClassDayPriceList;
      } else {
        // this.orgLineClassDayPriceList.forEach((element) => {
        //   if (element.NodeGroup == item.name) {
        //     this.lineClassDayPriceList.push(element);
        //   }
        // });
        this.startNodeGroup = item.name;
        this.getLineClassDayPrice();
      }
      this.startNodeShow = false;
    },

    //下车站点分组选择
    onArrivalNodeGroupSelect(item) {
      this.pageNumber = 1;
      this.total = 0;
      this.selectArrivalNodeGroup =
        item.name == "取消选择" ? "点击选择下车站点分组" : item.name;
      this.lineClassDayPriceList = [];
      if (item.name == "取消选择") {
        this.arrivalNodeGroup = "";
        this.getLineClassDayPrice();
        //this.lineClassDayPriceList = this.orgLineClassDayPriceList;
      } else {
        // this.orgLineClassDayPriceList.forEach((element) => {
        //   if (element.NodeGroup == item.name) {
        //     this.lineClassDayPriceList.push(element);
        //   }
        // });
        this.arrivalNodeGroup = item.name;
        this.getLineClassDayPrice();
      }
      this.arrivalNodeShow = false;
    },
  },
  mounted: function () {
    this.getLineClassDayPrice();
    this.onLineStartNodeNodeGroupNameQuery();
    this.onLineArrivalNodeNodeGroupNameQuery();
  },
  created() {},
};
</script>

<style scoped lang="less">
.LineTitle {
  line-height: 1rem;
  font-size: 16px;
  text-align: left;
  padding: 0.1rem;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  font-weight: 700;
  background-color: #59b2df;
  color: white;
  /* margin: 0.2rem; */
}
.priceTitle {
  font-size: 12px;
  font-weight: 600;
}
.priceList {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  background-color: white;
  padding: 0.1rem;
}
.priceDetail {
  background-color: #f2f2f2;
  margin-top: 0.2rem;
  padding: 0.2rem;
  border-radius: 0.3rem;
}
.btnDiv {
  text-align: left;
  padding-left: 0.3rem;
  margin-top: 0.1rem;
}
.dialogEdit {
  padding: 0.1rem;
  margin-top: 0.2rem;
}
</style>
